import { useCallback, useEffect, useState } from "react";
import { api, apiError } from "@/lib/api";
import { ErrorState, Loading } from "@/components/States";
import { useAuth } from "@/context/AuthContext";
import { StudentHomeContent } from "@/pages/student/StudentHomeContent";

export default function StudentHome() {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");
  const [editing, setEditing] = useState(false);
  const { refresh } = useAuth();

  const load = useCallback(async () => {
    setError("");
    try {
      const res = await api.get("/student/home");
      setData(res.data);
    } catch (err) {
      setError(apiError(err, "No pudimos cargar tu inicio."));
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const saveAvatar = async (config) => {
    await api.patch("/student/avatar", { avatar_config: config });
    await refresh();
    await load();
  };

  if (error) return <ErrorState message={error} onRetry={load} />;
  if (!data) return <Loading label="Preparando tu estudio..." />;

  return (
    <StudentHomeContent
      data={data}
      editing={editing}
      onToggleEditing={() => setEditing((value) => !value)}
      onSaveAvatar={saveAvatar}
    />
  );
}
